import { IconCheck3, IconArrowRight, IconSize } from '@axafr-btc-ds/icons';
import { Link } from '@axafr-btc-ds/link';
import { Typography } from '@axafr-btc-ds/typography';
import { ColorHex } from '@axafr-btc-ds/colors';
import classNames from 'classnames';
import { ProductModal } from 'components';
import { MouseEvent, useState } from 'react';
import { ProductProps } from './Product.interface';
import styles from './Product.module.css';
import { ProductIcons } from './Product.utils';

export const Product = ({ code, title, seeMore, selected }: ProductProps): JSX.Element => {
    const [ isModalOpen, setIsModalOpen ] = useState<boolean>(false);

    const Icon = ProductIcons[ code ];

    const handleSeeMoreClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        setIsModalOpen(true);
    };

    const handleModalClose = (event: MouseEvent<HTMLButtonElement | HTMLDivElement>
        | React.KeyboardEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setIsModalOpen(false);
    };

    const renderIcon = ({ className } = { className: '' }) => (
        <>
            { Icon &&
                <span data-testid="icon">
                    <Icon className={ className } />
                </span>
            }
        </>
    );

    const ProductIcon = renderIcon;

    return (
        <div className={ styles.host }>
            <div className={ styles.header }>
                <div>
                    <ProductIcon className={ styles.leftIcon } />
                </div>
                <div className={ classNames(styles.radio, { [ styles.selected ]: selected }) }>
                    { selected &&
                    <span data-testid="selected-icon">
                        <IconCheck3
                            color={ ColorHex.ghostwhiteClassic }
                            size={ IconSize.x3u }
                            className={ styles.icon }
                        />
                    </span>
                    }
                </div>
            </div>

            <Typography id={ code } variant="body1" bodyFontWeight="600" className={ styles.title }>
                { title }
            </Typography>

            { seeMore && (
                <>
                    <Link
                        className={ styles.more }
                        onClick={ handleSeeMoreClick }
                    >
                        <IconArrowRight className={ styles.moreIcon } />
                        <span>En savoir plus</span>
                    </Link>

                    { isModalOpen && (
                        <ProductModal
                            content={ seeMore }
                            isOpen={ isModalOpen }
                            onClose={ handleModalClose }
                            renderIcon={ renderIcon }
                            title={ title }
                        />
                    ) }
                </>
            ) }
        </div>
    );
};
